/**
 * loại chứng từ
 */
export default {
  /* -----------------------------------------------------
  Cấu hình RefType các chứng từ được sinh ra từ chứng từ Salagov
   ------------------------------------------------------ */

  // Phiếu chi
  CAPayment: 21,
  // Rút tiền Kho bạc
  BUTreasuryWithdrawal: 31,
  // Chi tiền gửi
  BAWithDraw: 33,
  // Chuyển khoản kho bạc
  BUTransfer: 34,
  // Chuyển khoản kho bạc vào tài khoản tiền gửi
  BUTransferDeposit: 165,
};
